export type TariffCategory =
  | '2Rate'
  | '2RateHeating'
  | '3Rate'
  | '3RateEWHeating'
  | '3RateHeating'
  | '4Rate'
  | 'Anytime'
  | 'DomesticEconomy'
  | 'Economy10'
  | 'Economy7'
  | 'Economy9'
  | 'EconomyHeatingLoad'
  | 'FlexRate'
  | 'Heatwise2Rate'
  | 'Heatwise3Rate'
  | 'Superdeal'
  | 'THTC'
  | 'Unknown'
  | 'Unsupported';

export enum EnergyAcquisitionFuelType {
  Electricity = 'Electricity',
  Dual = 'Dual',
  Gas = 'Gas',
}

export type MeterRelationship = {
  primaryMeterPointNumber: string;
  secondaryMeterPointNumbers: string[];
};

export type MeterPaymentMechanism = 'PAYM' | 'PAYG';

export type MeterType = 'S1' | 'S2' | 'CREDIT' | 'PAYG' | 'Unknown';

export type MeterPaymentCombination = 'PAYM' | 'PAYG' | 'PAYX';

export type AvailablePaymentMethods = 'Paym' | 'PayG' | 'PayX' | 'PayNonDD';

export type MeterInformationTariffCategory = 'anytime' | 'economy7';

export type MeterInformation = {
  paymentMethod: MeterPaymentMechanism;
  meterType: MeterType;
  fuel: EnergyAcquisitionFuelType;
  category: MeterInformationTariffCategory;
  profileClass?: string | null;
  ovoSupplied: boolean;
  mpxn?: string;
};

export type EnergyQuoteEligibility = {
  gasMeterInformation: MeterInformation[];
  electricityMeterInformation: MeterInformation[];
  electricityMeterTariffCategory: TariffCategory;
  supplier: 'OVO' | 'Other';
  supportStatus: 'Fast' | 'Slow' | 'None' | 'exception';
  missingMeters: Array<'gas' | 'elec'>;
  meterPaymentCombination: MeterPaymentCombination;
  availablePaymentMethods: AvailablePaymentMethods[];
  requestedFuel: EnergyAcquisitionFuelType;
  exceptionsReasons: Exceptions[];
  customerType: 'multi-rate' | 'multi-meter' | 'mrmm' | 'standard';
  tariffCategory: TariffCategory;
  addressQuality: 'resolved' | 'manual';
  meterRelationship?: MeterRelationship[];
};

export enum Exceptions {
  MultipleUnrelatedMpans = 'MultipleUnrelatedMpans',
  RelationshipHasMoreSecondaryMpans = 'RelationshipHasMoreSecondaryMpans',
  MoreMultimeters = 'MoreMultimeters',
  CotWithMultimeter = 'CotWithMultimeter',
  CotWithMultirateMeter = 'CotWithMultirateMeter',
  OvoApolloMigrationIsNeeded = 'OvoApolloMigrationIsNeeded',
  UnsupportedMeterSetup = 'UnsupportedMeterSetup',
  UnrecognisedTariffCategory = 'UnrecognisedTariffCategory',
  NotSupportedInOrion = 'NotSupportedInOrion',
  UnmeteredSuppyPoint = 'UnmeteredSuppyPoint',
  HasElectiveHalfHourlyMeter = 'HasElectiveHalfHourlyMeter',
  HasSmartMultimeter = 'HasSmartMultimeter',
  HasTraditionalPayGMultimeter = 'HasTraditionalPayGMultimeter',
  HasTraditionalPayGMultirateMeter = 'HasTraditionalPayGMultirateMeter',
  HasSmartMultirateMeter = 'HasSmartMultirateMeter',

  // Custom exception to standardise UI behaviour
  CotWithMeterPC00 = 'CotWithMeterPC00',
  CotWithUnrelatedMpans = 'CotWithUnrelatedMpans',
  UnsupportedCosMeterPC00 = 'UnsupportedCosMeterPC00',
  MRMMSupportedInDevelopment = 'MRMMSupportedInDevelopment',
  UnsupportedBusinessMeter = 'UnsupportedBusinessMeter',
}
